;(function () {
  'use strict'

  angular.module('contrast.servers').constant('SERVER_EVENTS', {
    UPDATE_SERVER: 'update:server'
  })
})()
